/**
 * Boolean Formatter.
 * @param {*} value
 * @returns {*}
 */
window.booleanFormatter = function(value) {
    if (parseInt(value, 10) === 1 || value === "TRUE") {
        return '<i class="fas fa-check text-success"></i>';
    }
};
